import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { updateP2pActiveTab } from "../../../../../store/Actions/P2PActions";

import { P2PTableTab } from "../../../../Units/TabsAndLinkStyled";
import DashboardHeader from "../../DashboardHeader";
import OverviewStats from "./OverviewStats";
import { useHistory } from "react-router-dom";
import WalletStats from "./WalletStats";
import ActivitiesCardTable from "./ActivitiesCardTable";

const PeerToPeerOveriew = ({ activeTab, updateActiveTab }) => {
  const location = useLocation();
  const links = [
    { text: "Overview", tab: "overview" },
    { text: "Ads", tab: "ads" },
    { text: "Orders", tab: "orders" },
  ];

  const linkKeys = {
    all: 0,
    ads: 1,
    orders: 2,
  };

  const router = useHistory();

  const handleTabChange = (tab) => {
    // updateActiveTab(links[tab].tab);

    console.log("tab", tab);

    console.log("dd", links[tab].tab);

    router.push(`/dashboard/p2p/${links[tab].tab}`);
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Peer-to-peer</title>
        <link rel="canonical" href={location.pathname} />
      </Helmet>
      <DashboardHeader>Peer-to-peer</DashboardHeader>
      {/* <h2>{activeTab}</h2> */}
      <div>
        <P2PTableTab
          margin
          tabs={links}
          activeTab={0}
          handleTab={handleTabChange}
          p={"16px 0px"}
          boxShadow={"0px"}
          borderRadius={"0px"}
          activeBg={"#FAFBFD"}
          activeColor={"#005674"}
          color={"#646A86"}
          activeOutline={"none"}
          activeOutlineBottom={"2px solid #005674"}
          tailwindpad
          callback={(active) => {
            console.log("hello");
            console.log(active);
            // updateActiveTab(links[active].tab);
          }}
        />
      </div>
      <div className="">
        <div>
          <div className="flex flex-wrap overflow-hidden">
            <div className="w-full overflow-hidden lg:w-8/12 xl:w-8/12">
              <OverviewStats />
              <ActivitiesCardTable />
            </div>
            <div className="w-full overflow-hidden lg:px-6 xl:px-6 lg:w-4/12 xl:w-4/12">
              <WalletStats />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    activeTab: state.p2p.p2pActiveTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveTab: (tab) => dispatch(updateP2pActiveTab(tab)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PeerToPeerOveriew);
